import React, { Component } from 'react';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { motion, AnimatePresence } from 'framer-motion';

/* Icons */
import SearchIcon from '~/../symbols/search.svg';
import SearchAltIcon from '~/../symbols/search-alt.svg';

/* Config */
import { reactToastifyConfig } from '~/config';

/* Components */
import SearchOverlay from './SearchOverlay';

/* Common */
import { Button } from '~/components/common';

/* Constants */
import { fadeInOut } from '~/constants/animations'

/* Utilities */
import { trans } from '~/utilities';

export default class Search extends Component {
    constructor(props) {
        super(props);

        this.matchMedia = window.matchMedia('(min-width: 1280px)');
        this.variants = {
            initial: (isDesktop) => {
                if (isDesktop) {
                    return {
                        clipPath: 'inset(0 0 0 100%)',
                        opacity: 0,
                        transition: { ease: 'easeInOut', duration: 0.45 },
                    };
                } else {
                    return {
                        clipPath: 'inset(0 100% 0 0)',
                        transition: { ease: 'easeInOut', duration: 0.45 },
                    };
                }
            },
            animate: {
                x: 0,
                opacity: 1,
                clipPath: 'inset(0 0% 0 0%)',
                transition: { ease: 'easeInOut', duration: 0.45 },
            },
            exit: (isDesktop) => {
                if (isDesktop) {
                    return {
                        clipPath: 'inset(0 0 0 100%)',
                        opacity: 0,
                        transition: { ease: 'easeInOut', duration: 0.45 },
                    };
                } else {
                    return {
                        clipPath: 'inset(0 100% 0 0)',
                        transition: { ease: 'easeInOut', duration: 0.45 },
                    };
                }
            },
        }

        this.state = {
            results: {},
            isOpen: false,
            isLoading: true,
            query: '',
            isDesktop: this.matchMedia.matches,
        };

        toast.configure(reactToastifyConfig);
        this.matchMedia.addListener(this.mediaListener);
    }

    componentWillUnmount = () => {
        this.matchMedia.removeListener(this.mediaListener);
    }

    mediaListener = (event) => {
        this.setState({ isDesktop: event.target.matches });
    };

    fetchData = () => {
        this.setState({ isLoading: true, });

        Axios.get(this.props.searchUrl, { params: { query: this.state.query } }).then((response) => {
            if (response.data) {
                this.setState({
                    results: response.data,
                });
            }
        }).catch((error) => {
            toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
            throw new Error(error);
        }).finally(() => {
            this.setState({ isLoading: false });
        });
    };

    updateQuery = (query) => {
        this.setState({ query: query }, () => this.fetchData());
    }

    openSearch = () => {
        this.setState({ isOpen: true, results: {}, query: '' });
    }

    closeSearch = () => {
        this.setState({ isOpen: false });
    }

    render() {
        const isAlmn = this.props.searchWebspace === 'almn';

        return (
            <div className="search">
                <Button
                    theme="none"
                    className={isAlmn ? 'p-0 d-flex align-items-center' : 'p-0'}
                    showTitle={isAlmn}
                    title={isAlmn ? 'Zoeken' : trans('app.header.search.title')}
                    showIcon={true}
                    icon={isAlmn ? SearchAltIcon : SearchIcon}
                    iconSize={isAlmn ? 24 : 20}
                    iconTheme={isAlmn ? 'base' : 'white'}
                    iconClassName={isAlmn ? 'icon--search' : ''}
                    textClassName={isAlmn ? 'ml-lg-4 font-weight-bold d-none d-xl-block' : ''}
                    onClick={this.openSearch}
                />
                <AnimatePresence initial={false} exitBeforeEnter>
                    {this.state.isOpen && (
                        <>
                            <motion.div key="backdrop" {...fadeInOut} className="search__backdrop" onClick={this.closeSearch} />
                            <motion.div
                                key="overlay"
                                className="search__overlay"
                                custom={this.state.isDesktop}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                                variants={this.variants}
                            >
                                <SearchOverlay
                                    results={this.state.results}
                                    query={this.state.query}
                                    updateQuery={this.updateQuery}
                                    closeSearch={this.closeSearch}
                                    resultsUrl={`/zoeken?query=${this.state.query}`}
                                />
                            </motion.div>
                        </>
                    )}
                </AnimatePresence>
            </div>
        );
    }
}
